import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import ScriptLoader from 'yoda-core-components/lib/helpers/ScriptLoader/ScriptLoader';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';
import LoaderAction from 'yoda-site-components/lib/actions/LoadingAction';
import { getSelectedColor } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import {
    selectPreferences,
    selectFeatureFlags,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import {
    miniPDPOnShopTheSetOpen,
    miniPDPOnClose,
    miniPdpAtcFromSTS,
} from 'yoda-site-components/lib/actions/MiniPDPAction';
import {
    getPriceFormatWithCommas,
    decimalRounding,
} from 'yoda-site-components/lib/helpers/Pricing/Pricing';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import {
    requestShopTheLookPricing,
    updateLastSelectedColor,
} from 'yoda-site-components/lib/actions/ShopTheLookAction';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import User from 'yoda-site-components/lib/helpers/User/User';
import { ACCOUNT_ID } from 'yoda-site-components/lib/common/Constants';
import { shopTheSetLoadSuccess, shopTheSetClickEvent } from '../../actions/AnalyticsAction';
import ProductConstants from '../../helpers/ProductConstants';
import * as styles from './ShopTheSet.css';

const cx = classNames.bind(styles);

export class ShopTheSet extends Component {
    static propTypes = {
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productPrices: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        selectedColor: PropTypes.string,
        lastSelectedColor: PropTypes.string,
        outfitsData: PropTypes.func,
        jumpLink: PropTypes.func,
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        preferences: PropTypes.oneOfType([PropTypes.object]),
        miniPDP: PropTypes.oneOfType([PropTypes.object]),
        featureFlags: PropTypes.object,
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    };

    static defaultProps = {
        productDetails: {},
        productPrices: [],
        selectedColor: '',
        lastSelectedColor: '',
        outfitsData: null,
        jumpLink: null,
        actions: {},
        preferences: {},
        miniPDP: {},
        featureFlags: {},
        deviceType: {},
    };

    constructor(props) {
        super(props);
        this.styliticsWidgetObj = null;
        this.state = {
            scriptLoaded: false,
            outfitsFromWidget: [],
            outfitsSetWidget: [],
            outfitsLoadWidget: [],
            hideLoader: false,
            jumpLinkImage: null,
            analyticsTriggered: false,
        };
        this.stylisticsSetRef = React.createRef();
        this.jumpLinkImg = null;
    }

    /* istanbul ignore next */
    observer =
        !__SERVER__ &&
        new MutationObserver((mutationsList, observer) => {
            this.jumpLinkImg =
                (this.stylisticsSetRef &&
                    this.stylisticsSetRef.current.querySelectorAll(
                        `.stylitics-ms-widget-root .stylitics-ms-set-item-carousel .stylitics-ms-set-item-image img`
                    )) ||
                [];
            this.setState({ jumpLinkImage: this.jumpLinkImg });
            observer.disconnect();
        });

    componentDidMount() {
        this.loadScript();
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const {
            miniPDP: { miniPDPSTSATC = false },
            actions,
        } = this.props;

        const newMiniPDPState = nextProps?.miniPDP?.miniPDPSTL;
        const currentMiniPDPState = this.props?.miniPDP?.miniPDPSTL;
        if (newMiniPDPState !== currentMiniPDPState) {
            window.history.pushState(null, null, window.location.href);
            if (newMiniPDPState === 'open') {
                window.onpopstate = function () {
                    actions.miniPDPOnClose();
                };
            }
            if (newMiniPDPState === 'close') {
                window.onpopstate = function () {
                    window.history.back();
                };
            }
        }

        /* istanbul ignore if */
        if (nextProps.miniPDP && nextProps.miniPDP.miniPDPSTSATC && !miniPDPSTSATC) {
            // To trigger stylitics analytics method when add to cart CTA is clicked from mini PDP
            const itemId = get(nextProps, 'miniPDP.itemIdSTS', '');
            !isEmpty(itemId) && this.styliticsWidgetObj.trackAddItemToCart(itemId);
            // To trigger miniPdpAtcFromSTS action to enable next add to cart.
            actions.miniPdpAtcFromSTS && actions.miniPdpAtcFromSTS(false);
        }

        /* istanbul ignore next */
        Object.keys(this.state.outfitsSetWidget).length > 0 &&
            this.observer.observe(document, {
                childList: true,
                subtree: true,
            });
    }

    shouldComponentUpdate(nextProps, nextState) {
        const { selectedColor, productPrices } = this.props;
        const { outfitsFromWidget, outfitsLoadWidget, hideLoader, jumpLinkImage } = this.state;

        if (selectedColor && selectedColor !== nextProps.selectedColor) {
            return true;
        }

        if (nextState.outfitsFromWidget !== outfitsFromWidget) {
            return true;
        }

        if (nextState.outfitsLoadWidget !== outfitsLoadWidget) {
            return true;
        }

        if (nextState.jumpLinkImage !== jumpLinkImage) {
            this.props.outfitsData(nextState.outfitsLoadWidget);
            return true;
        }

        if (nextState.hideLoader !== hideLoader) {
            return true;
        }
        if (nextProps.productPrices !== productPrices) {
            return true;
        }

        return false;
    }

    componentDidUpdate(prevProps) {
        const { outfitsLoadWidget, analyticsTriggered, jumpLinkImage } = this.state;
        const digitalData = window && window.digitalData;
        /* istanbul ignore next */
        if (
            this.isWidgetLoaded() &&
            this.props.selectedColor &&
            this.props.selectedColor !== prevProps.selectedColor
        ) {
            this.refreshContent();
        }
        this.getPriceData();
        if (jumpLinkImage && outfitsLoadWidget.length > 0 && digitalData) {
            if (!analyticsTriggered) {
                this.props.actions.shopTheSetLoadSuccess(digitalData);
                this.setState({
                    analyticsTriggered: true,
                });
            }
        }
    }

    isWidgetLoaded = () => document.getElementsByClassName('stylitics-ms-widget-root');

    isSTLWidgetLoaded = () => document.getElementsByClassName('stylitics-dimension-collage-base');

    loadScript = () => {
        const { preferences } = this.props;
        const stlScriptURLDimensionsUpgrade = get(
            preferences,
            'shopTheLook.stlScriptURLDimensionsUpgrade',
            ''
        );
        const stylisticsProps = {
            src: stlScriptURLDimensionsUpgrade,
            async: true,
            defer: false,
            onSuccess: () => {
                /* istanbul ignore next */
                this.initiateShopTheLookFeature();
            },
        };
        ScriptLoader.load(stylisticsProps);
        this.setState({
            scriptLoaded: true,
        });
    };

    getOptionsForShopTheLook = () => {
        const profileID = User.isUserLoggedIn(true) ? TokenProvider.get(ACCOUNT_ID) : 'NA';
        const opts = {
            api: {
                min: 3,
                max: 10,
                item_number: this.getItemNumber(this.props.selectedColor),
            },
            text: {
                viewDetailsCTA: ProductConstants.SHOP_THE_LOOK,
                itemLinkCTA: ProductConstants.SHOP_ATC,
            },
            customer: {
                identifier: 'jcpenney',
                profileId: profileID,
            },
            price: {
                salesPriceStyle: 'sales-price-only',
            },
        };
        return opts;
    };

    getItemNumber = (selectedColor) => {
        const { productDetails } = this.props;
        const selectedColorName = selectedColor || productDetails.ppFeatureColor;
        const itemNumber = selectedColorName
            ? `${productDetails.id}_${selectedColorName.replaceAll(' ', '-').toLowerCase()}`
            : '';
        return itemNumber;
    };

    constructPPid = (bundleOutfits) => {
        const productIds = [];
        if (bundleOutfits) {
            bundleOutfits.forEach((subelement) => {
                productIds.push(subelement.remote_id.split('_')[0]);
            });
        }
        return productIds;
    };

    refreshJumplink = (data = false) => {
        const jumplinkElement = document.getElementById('stylitics-jumplink');
        const titleElement = document.getElementById('widget-title-STS');
        /* istanbul ignore next */
        if (jumplinkElement && titleElement && !data) {
            jumplinkElement.style.display = 'block';
            titleElement.style.display = 'block';
        } else if (data) {
            if (this.isSTLWidgetLoaded().length === 0) {
                jumplinkElement.style.display = 'none';
            }
            titleElement.style.display = 'none';
        }
    };

    /* istanbul ignore next */
    getItemCtaLinkText = (itemName, productId) => {
        const ref = this.stylisticsSetRef?.current;
        const liCtaSpan = itemName
            ? ref
                  ?.querySelector(`li.stylitics-outfit-item [aria-label="${itemName}"]`)
                  ?.closest('li.stylitics-outfit-item')
                  ?.querySelector('.stylitics-cta-text.stylitics-outfit-list-item-cta-button-text')
            : null;
        const anchorCtaSpan = ref
            ?.querySelector(`a.item-cta[href*="${productId}"]`)
            ?.querySelector('.stylitics-cta-text:not(.stylitics-outfit-list-item-cta-button-text)');
        return liCtaSpan?.textContent?.trim() || anchorCtaSpan?.textContent?.trim() || 'Shop';
    };

    /* istanbul ignore next */
    initiateShopTheLookFeature = () => {
        const { scriptLoaded } = this.state;
        const { actions, featureFlags } = this.props;
        /* istanbul ignore next */
        if (scriptLoaded) {
            let selectPrevColor = '';
            const opts = this.getOptionsForShopTheLook();
            this.styliticsWidgetObj = new StyliticsShopTheSetWidget(
                'jcpenney_intimates_matching_sets',
                'shopSetContainer',
                opts
            );
            this.styliticsWidgetObj.on('mount', 'set', (data) => {
                if (Object.keys(data.items).length > 0) {
                    this.setState({
                        outfitsFromWidget: data.collection_ids,
                        outfitsSetWidget: data.items,
                    });
                } else {
                    this.setState({
                        outfitsFromWidget: [],
                        outfitsSetWidget: [],
                    });
                }
            });

            this.styliticsWidgetObj.on('load', 'data', (data) => {
                this.setState({
                    hideLoader: true,
                });
                let bundleOutfits = [];
                let bundlebottomItems = [];
                let bundletopItems = [];
                if (Object.keys(data).length > 0) {
                    bundlebottomItems = get(data, 'bottomItems', []);
                    bundletopItems = get(data, 'topItems', []);
                    if (Object.keys(bundlebottomItems).length > 0) {
                        bundleOutfits = [...bundlebottomItems];
                    }
                    if (Object.keys(bundletopItems).length > 0) {
                        bundleOutfits = [...bundleOutfits, ...bundletopItems];
                    }
                    if (bundleOutfits.length > 0) {
                        this.setState({
                            outfitsLoadWidget:
                                bundletopItems.length > 0 ? bundletopItems : bundlebottomItems,
                        });
                        this.refreshJumplink();
                        actions.updateLastSelectedColor(this.props.selectedColor);
                        const selectedColorData = get(data, '[0].remote_id', '');
                        selectPrevColor = selectedColorData && selectedColorData.split('_')[1];
                        actions.requestShopTheLookPricing(this.constructPPid(bundleOutfits));
                    } else {
                        selectPrevColor !== '' && this.refreshContent(selectPrevColor);
                        this.setState({
                            outfitsLoadWidget: [],
                        });
                        this.refreshJumplink(true);
                    }
                }
            });

            this.styliticsWidgetObj.override('click', 'item', ({ item }) => {
                const position = (this.state.outfitsLoadWidget || []).findIndex(
                    (i) => i.item_id === item?.item_id
                );
                const linkPosition = position >= 0 ? position : 0;
                const productId = get(item, 'remote_id', '').split('_')[0];
                const itemName = get(item, 'name', '');
                const linkText = this.getItemCtaLinkText(itemName, productId);
                this.onShopTheLookItemClick(item, linkPosition, linkText);
            });

            this.styliticsWidgetObj.start();
        }
    };

    onShopTheLookItemClick = (ppId, position = 0, linkText = '') => {
        /* istanbul ignore next */
        const skuData = get(ppId, 'remote_id', '');
        const itemId = get(ppId, 'item_id', '');
        const { actions } = this.props;
        const skuID =
            (ppId &&
                get(ppId, 'other_client_item_ids.sku_nbrs', '') &&
                !isEmpty(ppId.other_client_item_ids.sku_nbrs) &&
                ppId.other_client_item_ids.sku_nbrs[0]) ||
            '';
        /* istanbul ignore next */
        if (!isEmpty(skuData)) {
            const options = {
                ppId: skuData.split('_')[0],
                skuId: skuID,
            };
            const customEvent = document.createEvent('CustomEvent');
            customEvent.initCustomEvent('miniPDP.open', true, true, options);
            document.dispatchEvent(customEvent);
            actions.miniPDPOnShopTheSetOpen(itemId);
            actions.shopTheSetClickEvent({
                shopTheSetID: itemId.toString() || '',
                shopTheSetPPID: options.ppId,
                moduleName: ProductConstants.SHOP_THE_SET.toLowerCase(),
                linkText,
                linkPosition: position,
            });
            // To trigger stylitics analytics method when add to cart CTA is clicked which is present with in widget.
            this.styliticsWidgetObj.trackClickItem(skuData);
        }
    };

    /* istanbul ignore next */
    getPriceData = () => {
        const { productPrices, deviceType } = this.props;
        const { outfitsSetWidget } = this.state;
        let pricingBlockData = '';
        if (productPrices && productPrices.length) {
            productPrices[0].allProducts.forEach((price) => {
                if (this.stylisticsSetRef && outfitsSetWidget && outfitsSetWidget.length > 0) {
                    const getItem = outfitsSetWidget.filter(
                        (data) => data?.product_id === price.id
                    );
                    const isMobile = this.stylisticsSetRef.current.querySelectorAll(
                        `.stylitics-ms-is-mobile`
                    );
                    const priceData = get(price, 'pricing.root', {});
                    if (
                        getItem &&
                        getItem.length > 0 &&
                        priceData &&
                        Object.keys(priceData).length > 0
                    ) {
                        const topPriceLabel = this.stylisticsSetRef.current.querySelectorAll(
                            `.stylitics-ms-set-item-top-carousel .stylitics-ms-set-item-name`
                        );
                        const bottomPriceLabel = this.stylisticsSetRef.current.querySelectorAll(
                            `.stylitics-ms-set-item-bottom-carousel .stylitics-ms-set-item-name`
                        );
                        const topPrice =
                            isMobile && isMobile.length > 0
                                ? this.stylisticsSetRef.current.querySelectorAll(
                                      `[data-stylitics-item-id*="${getItem[0]?.item_id}"].stylitics-ms-set-item-top .stylitics-ms-set-item-details .stylitics-ui-price .stylitics-ui-regular-price`
                                  )
                                : topPriceLabel &&
                                  topPriceLabel.length > 0 &&
                                  getItem[0].name === topPriceLabel[0].innerText &&
                                  this.stylisticsSetRef.current.querySelectorAll(
                                      `.stylitics-ms-set-item-top-carousel .stylitics-ui-price .stylitics-ui-regular-price`
                                  );
                        const bottomPrice =
                            isMobile && isMobile.length > 0
                                ? this.stylisticsSetRef.current.querySelectorAll(
                                      `[data-stylitics-item-id*="${getItem[0]?.item_id}"].stylitics-ms-set-item-bottom .stylitics-ms-set-item-details .stylitics-ui-price .stylitics-ui-regular-price`
                                  )
                                : bottomPriceLabel &&
                                  bottomPriceLabel.length > 0 &&
                                  getItem[0].name === bottomPriceLabel[0].innerText &&
                                  this.stylisticsSetRef.current.querySelectorAll(
                                      `.stylitics-ms-set-item-bottom-carousel .stylitics-ui-price .stylitics-ui-regular-price`
                                  );
                        const couponInfo = get(price, 'pricing.root.couponInfo');
                        const eligibleCouponInfo = get(price, 'pricing.root.eligibleCouponInfo');
                        const isCoupon = couponInfo ?? eligibleCouponInfo ?? [];
                        const isAmount = get(price, 'pricing.root.amounts', []);
                        const amountType = get(isAmount[1], 'type', '');
                        const couponOrType = `<span class=${styles.itemPriceData}>${
                            isCoupon && isCoupon.length
                                ? ProductConstants.CODE
                                : isAmount &&
                                  isAmount.length &&
                                  amountType !== ProductConstants.DEFAULT
                                ? amountType.toLowerCase()
                                : ''
                        }</span>`;
                        if (isCoupon && isCoupon.length) {
                            pricingBlockData = `<span class=${dt([
                                'text-brand-red',
                            ])}> $${getPriceFormatWithCommas(
                                decimalRounding(get(isCoupon[0], 'amount.min', ''))
                            )} ${couponOrType} </span>`;
                        } else {
                            pricingBlockData =
                                isAmount &&
                                isAmount.length &&
                                isAmount[1].min &&
                                isAmount[1].max &&
                                isAmount[1].min !== isAmount[1].max
                                    ? `$${getPriceFormatWithCommas(
                                          decimalRounding(isAmount[1].min)
                                      )} - $${getPriceFormatWithCommas(
                                          decimalRounding(isAmount[1].max)
                                      )}`
                                    : `$${getPriceFormatWithCommas(
                                          decimalRounding(isAmount[1].min)
                                      )} ${couponOrType}`;
                        }
                        const priceBlock = topPrice && topPrice.length ? topPrice : bottomPrice;
                        const pricingData = `<span class=${dt([
                            'font-open-sans-bold',
                        ])}> ${pricingBlockData} </span>`;
                        if (priceBlock && priceBlock.length) {
                            priceBlock.forEach((element) => {
                                element.innerHTML = pricingData;
                            });
                        }
                    }
                }
            });
        }
    };

    refreshContent = (color = this.props.selectedColor) => {
        const { scriptLoaded } = this.state;
        /* istanbul ignore next */
        if (scriptLoaded && this.styliticsWidgetObj) {
            const itemNumber = this.getItemNumber(color);
            this.styliticsWidgetObj.refresh({ api: { item_number: itemNumber } });
            this.refreshJumplink();
        }
    };

    stylisticsMarkup = () => {
        const stylistics = `<style>
        .stylitics-ms-widget-root * {
            font-family: 'OPEN SANS' !important;
            font-size: 16px !important;
            line-height: 24px !important;
        }
        .stylitics-ms-is-mobile * {
            font-size: 14px !important;
            line-height: 20px !important;
        }
        .stylitics-ms-set-item-details {
            text-align: left !important;
        }
        .stylitics-ms-set-item-name {
            font-weight: 400 !important;
        }
        .stylitics-ms-set-item-position {
            color: black !important;
        }
        .stylitics-ui-carousel-card {
            grid-gap: 24px !important;
        }
        .stylitics-ui-button {
            border-color: #999999 !important;
            border-radius: 8px !important;
            font-weight: 600 !important;
        }
        .stylitics-item-regular-price {
            font-family: 'OPEN SANS';
            font-weight: 700 !important;
        }
        </style>`;
        return stylistics;
    };

    loadContent = () => {
        const { hideLoader } = this.state;
        const shopTheLookBlock = (
            <div>
                {!hideLoader && (
                    <div
                        className={dt([
                            'absolute',
                            'h-[400px]',
                            'left-0',
                            'right-0',
                            'z-[1]',
                            'm-auto',
                            'mt-4',
                        ])}
                    >
                        <Loader />
                    </div>
                )}

                <h4
                    id="widget-title-STS"
                    className={dt([
                        'text-center',
                        'font-open-sans-semibold',
                        '!leading-8',
                        'lg:text-xLg',
                        'sm:text-lg',
                        'pb-3',
                        'hidden',
                    ])}
                >
                    {ProductConstants.SHOP_THE_SET}
                </h4>
                <div
                    id="shopSetContainer"
                    className={`${cx('shopTheLookContainer')} ${dt([
                        'text-center',
                        'font-open-sans-semibold',
                        '!text-base',
                        'leading-7',
                        'mb-10',
                    ])}`}
                    dangerouslySetInnerHTML={{ __html: this.stylisticsMarkup() }}
                    ref={this.stylisticsSetRef}
                />
            </div>
        );
        return shopTheLookBlock;
    };

    render() {
        return <div>{this.loadContent()}</div>;
    }
}

const mapStateToProps = (state) => ({
    preferences: selectPreferences(state),
    selectedColor: getSelectedColor(false)(state),
    productPrices: state.shopTheLook ? state.shopTheLook.productPrices : {},
    lastSelectedColor: state.shopTheLook ? state.shopTheLook.lastSelectedColor : '',
    miniPDP: state.miniPDP ? state.miniPDP : {},
    featureFlags: selectFeatureFlags(state),
    deviceType: state.context.deviceType || {},
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...LoaderAction,
            requestShopTheLookPricing,
            updateLastSelectedColor,
            shopTheSetLoadSuccess,
            shopTheSetClickEvent,
            miniPDPOnShopTheSetOpen,
            miniPDPOnClose,
            miniPdpAtcFromSTS,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopTheSet);
